module.exports = __webpack_public_path__ + "img/violet_135.71152249.png";